export default "__VITE_ASSET__623c1ea2__"